/** Shared idle-session state for HIPAA timeout + axios auth handling. */

export const IDLE_WARN_MS = 15 * 60 * 1000; // 15 min → show warning
export const IDLE_LOGOUT_MS = 30 * 60 * 1000; // 30 min → force logout

let lastActivityMs = Date.now();
let warningOpen = false;

export function touchActivity(): void {
  lastActivityMs = Date.now();
}

export function getIdleMs(): number {
  return Date.now() - lastActivityMs;
}

export function isPastIdleWarn(): boolean {
  return getIdleMs() >= IDLE_WARN_MS;
}

export function setSessionWarningOpen(open: boolean): void {
  warningOpen = open;
}

/** True when idle timeout owns logout - block silent refresh / hard redirects. */
export function shouldSuppressAuthRedirect(): boolean {
  return warningOpen || isPastIdleWarn();
}

export function resetIdleSession(): void {
  touchActivity();
  warningOpen = false;
}
